import { AgnesAlert } from '@agnes/ui';
import { BadgeCentralReprocessamentoStatus } from '@/components/central-reprocessamento/BadgeCentralReprocessamentoStatus';

const MENSAGENS: Record<string, string> = {
  CRIADO: 'Este reprocessamento foi criado, mas ainda não teve a sua execução solicitada.',
  AGUARDANDO_SOLICITACAO:
    'Este reprocessamento está sendo solicitado. Por favor, aguarde um momento.',
  AGUARDANDO_APROVACAO:
    'Este reprocessamento já foi solicitado e está aguardando aprovação. Por favor, aguarde um momento.',
  AGUARDANDO_EXECUCAO: 'Este reprocessamento já foi aprovado e está aguardando o sua execução.',
  EM_ANDAMENTO: 'Este reprocessamento já está em andamento.',
  FINALIZADO: 'Este reprocessamento foi finalizado com sucesso.',
  ERRO: 'Este reprocessamento apresentou problemas.',
};

export function CentralReprocessamentoMensagemStatusAlert({
  reprocessamento,
}: Readonly<{ reprocessamento: any }>) {
  if (!reprocessamento?.status) return null;
  return (
    <AgnesAlert>
      <div className="flex flex-col gap-2">
        <BadgeCentralReprocessamentoStatus status={reprocessamento.status} className="self-start" />
        <p className="m-0">{MENSAGENS[reprocessamento.status]}</p>
        {reprocessamento.erro && (
          <div className="mt-2 border-t border-agnes-border pt-2">
            <p className="m-0">
              <b>Código</b>
            </p>
            <p className="m-0">{reprocessamento.erro?.codigo}</p>
            <p className="m-0 mt-2">
              <b>Descrição</b>
            </p>
            <p className="m-0 break-words">{reprocessamento.erro?.descricao}</p>
          </div>
        )}
      </div>
    </AgnesAlert>
  );
}
